// buildv notice

if (false) { // -- 실제 호출 가능한 위치
  fetch('/customer/notice')                // /jsp/customer/notice/notice.jsp
  fetch('/customer/notice/goNoticeDetail') // /jsp/customer/notice/noticeDetail.jsp
  fetch('/customer/notice/facility')       // /jsp/customer/notice/facilityInfo.jsp
}

import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from "./components/common/pagingUser.vue";
import Common from './components/common.js';
import DatePicker from 'vue2-datepicker';
import Editor from "./components/common/editor.vue";
import SwalAlert from "./components/common/swalAlert.vue";
import swal from 'sweetalert';
import Share from './components/common/share.js';
import 'vue2-datepicker/index.css';
import {get as _get, set as _set} from "lodash";


Vue.component("pager", Pager);
Vue.component('common', Common);
Vue.component("datepicker", DatePicker);
Vue.component('editor', Editor);
// var CircularJSON = require('circular-json');

const tabNameByType = {
  notice: '공지사항',
  event: '이벤트',
  press: '보도자료',
  faq: 'FAQ',
  qna: 'Q&A',
}

new Vue({
  el: '#app_notice',
  data: function () {
    return {
      find: '',
      mainName: '알림마당',
      tabType: 'notice', // notice, event, press, faq, qna
      tabName: '공지사항', // 공지사항, 이벤트, 보도자료, FAQ, Q&A
      subTab: 'ing',   // 서브탭

      inputQnatypeLabel: '',
      selectQnatypeType: '',

      faqNm: '전체',
      isDeclare: false,
      declareList: [],
      declareReportCode: '',
      declareReportEtc: '',
      isShare: false,
      rc: 1,
      rm: 1,

      searchModel: {
        startDate: '',
        endDate: '',
        subStartDate: '',
        subEndDate: '',
        bcate: '',
        kword: ''
      },

      noticeListModel: {
        list: [{"": ""}],
        faqList: [{"": ""}],
        bcate: 'notice',
        kind: 'all',
        kword: '',
        totalCount: 0,
        showMore: true,
        faqContent: [],
        eventContents: [],  // 이벤트
        pressContents: [],   // 보도자료
        pressSearch: '',

        isNotice: true,
        isEvent: false, // 이벤트
        isPress: false, // 보도자료
        isFaq: false,
        isQna: false,

        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            let searchid = $(".on").attr("id");

            if (searchid == 'News') {
              this.model.fnOnPostNews(n, 'news');
            } else {
              this.model.fnOnPostList(n);
            }

          }
        }
      },

      noticeDetailModel: {
        detail: {},
        prev: {},
        next: {},
        fileEtcList: [],
        fileImgList: [],
        fileVdList: []
      },

      noticeFaqModel: {
        list: [],
        detail: [{list: [{"": ""}], subList: [{"": ""}]}],
        bcate: 'faq',
        kind: 'all',
        kword: '',
        totalCount: 0,

        isFaq: true,
        isQna: false,

        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            this.model.fnOnPostFaq(n);
          }
        }
      },

      qnaInsertModel: {
        isInput: false,

        userId: '',
        userKey: '',
        name: '',
        phone: '',
        emailTop: '',
        emailKind: '',
        title: '',
        qnaType: '',
        inquiry: '',

        reserveTitle_input: '',
        reserveTitle: '',
        reservePuid: '',
        reserveID: '',
        reserveDate: '',

        centeruid: '',
        centername: '',
        centername_input: '',

        isEmptyPrgm: false,
      },

      facilityInfoModel: {
        aiFacList: [],
        facList: [{"": ""}],
        kind: 'all',
        kword: '',
        sort: 'newest',
        scopeValues: [],

        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 8,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            this.model.fnOnPostFacilityList(n);
          }
        }
      },

      viewModel: {
        //공통 사용 변수
        list: [{"": ""}],
        totalCount: 0,
        checkedValues: [],

        //공지사항 상세
        detail: {},
        prev: {},
        next: {},

        //레이어팝업 리스트
        popupList: [],

        //검색조건 리스트
        reserList: [],
        centerList: [],
        qnaTypeList: [],

        //검색 자동완성 변수
        isResActive: false,
        isCenActive: false,
        searchResQuery: '',
        searchCenQuery: '',
        resValue: '',
        cenValue: '',


        //페이징
        pager: {
          model: {},
          pageNo: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 10,
          list: [],
          href: "javascript:void(0);",
          etc: '',
          callBack: function (n) {

            let searchid = $(".current").attr("id");
            let _etc = this.model.viewModel.pager.etc;

            if (_etc == 'fnGetEventByMain') {
              this.model.fnGetEventByMain(n);
            } else if (_etc == 'fnGetPressByMain') {
              this.model.fnGetPressByMain(n);
              // } else if (searchid == 'News') {
              //   this.model.fnOnPostNews(n, 'news');
            } else {
              this.model.fnOnPostList(n);
            }

          }
        }
      }
    }
  },
  mounted: function () {
    let vm = this;
    vm.fnOnLoadInit();
    // vm.accordion();
    // vm.$nextTick(function () {
    //     vm.accordion();
    // });
  },
  created: function () {
    if (!('$' in Vue.prototype) && '$' in window) {
      Vue.prototype.$ = window.$;
    }
    let _data = this.$data.facilityInfoModel;
    let vm = this;
    let _keyList = Object.keys(_data);
    for (let values in _keyList) {
      let _values = _keyList[values];
      if (_values.indexOf("SelectBox") > -1) {
        _data[_values] = Common.fnFacSelectKindCode();
      }
    }
  },
  updated: function () {
    let vm = this;
    /*      vm.$nextTick(function () {
             vm.accordion();
         }); */

  },
  methods: {
    //리스트 출력 메소드
    fnOnLoadInit: function () {
      const vm = this;
      const pageType = $("#pageType").val();
      const tabType = $("#tabType").val();
      const subTab = $("#subTab").val();
      if (subTab) {
        vm.subTab = subTab || 'ing'
      }


      if ("list" == pageType) { // 목록 페이지에서 호출시 -- /customer/notice

        const searchWord = $("#searchWord").val();
        const pageNum = $("#pageNum").val() || 1;

        // console.log(`tabType = ${tabType}`)
        // console.log(`pageNum = ${pageNum}`)

        switch (tabType) {
          case 'notice':
            vm.noticeListModel.kword = searchWord
            vm.fnSetNoticeByTab(pageNum);
            break;
          case 'event':
            vm.fnSetEventByTab(pageNum, subTab);
            break;
          case 'press':
            vm.fnSetPressByTab(pageNum);
            break;
          case 'faq':
            vm.fnSetFaqByTab(pageNum, subTab);
            break;
          case 'qna':
            let _qnaType = $("#qnaType").val()
            vm.fnSetQnaByTab(_qnaType)
            break;
          default:
            alert(`정의되지 않은 tabType = ${tabType}`)
            break;
        }


        // if(pageNum !== null && pageNum !== ""){
        //     vm.noticeListModel.kword = searchWord;
        //     vm.fnSetNoticeByTab(pageNum)
        //     // alert('공지냐')
        //     // vm.fnOnPostList(pageNum);
        //     // vm.fnOnSetQnaType();
        // }else{
        //     vm.fnOnPostList(1);
        //     vm.fnOnSetQnaType();
        //     let _qnaType = $("#qnaType").val();
        //
        //     if(_qnaType != null && _qnaType != ""){
        //         if(_qnaType == "faq") {
        //           setTimeout(function() { vm.fnSetFaqByTab(); }, 300);
        //         } else if (_qnaType == "event") {
        //           setTimeout(function() { vm.fnSetEventByTab(); }, 300);
        //         } else if (_qnaType == "press") {
        //           setTimeout(function() { vm.fnSetPressByTab(); }, 300);
        //         } else {
        //           setTimeout(function() { vm.fnSetQnaByTab(_qnaType); vm.fnAllSetQna(); }, 300);
        //         }
        //     }
        // }

      } else if ("detail" == pageType) { // 상세 페이지에서 호출시 -- /customer/notice/goNoticeDetail

        const kakao_isInitialized = Kakao.isInitialized(); // 이미 초기화 되었는지 여부
        // Axios.post("/sc_log?type=debug&step=1", {kakao_isInitialized})
        if (!kakao_isInitialized) { // 초기화 안된 경우에만
          try {
            const result = Kakao.init("25727a9190252a67c490a909452aecd8"); // 초기화
            // Axios.post("/sc_log?type=debug&step=2", {result})
          } catch (e) {
            Axios.post("/sc_log?type=error&step=3", {javascript_error: e}) // 오류시 도대체 뭔 오류인지 로깅
          }
        }

        vm.fnSetCode("RPTNVYTHNV00000");
        vm.fnPostDetail();

      } else if ("facList" == pageType) {
        vm.mainName = "진로체험활동";
        vm.fnOnPostFacilityList(1);
      }
    },

    /**
     * tabType 기준으로 UI 설정
     * @param tabType
     */
    fnSetUIbyTabType: function (tabType) {

      // 탭 class
      $(".notice_tabs li").removeClass("on");
      $("#" + tabType).addClass("on");

      // 현재 위치 이름
      this.tabType = tabType
      this.tabName = tabNameByType[tabType] || 'ERROR'

    },
    funLocationBarUpdate: function (queryMap = {}) {
      const {pageNum, ...etcMap} = queryMap
      Common.fnLocationBarChangeQuery({
        tabType: this.tabType,
        pageNum: queryMap.pageNum == 1 ? null : queryMap.pageNum,
        ...etcMap
      })
    },

    fnOnPostList: function (pageNumber) {
      // console.log(`fnOnPostList() pageNumber = ${pageNumber}`)
      const vm = this;
      if (pageNumber < 2) vm.noticeListModel.list = [];
      vm.noticeListModel.pager.pageNo = pageNumber;

      const param = {
        pageNo: vm.noticeListModel.pager.pageNo,
        pageSize: vm.noticeListModel.pager.rowSize,
        kind: '',
        kword: vm.noticeListModel.kword,
      };

      // vm.funLocationBarUpdate({pageNum: pageNumber, qnaType: null})
      Axios.post("/api/notice/list", param).then(function (response) {

        vm.noticeListModel.pager.totalSize = response.data.totalCount;
        vm.noticeListModel.pageNum = (vm.noticeListModel.pager.pageNo * vm.noticeListModel.pager.rowSize) - vm.noticeListModel.pager.rowSize;
        Pager.props = Pager.methods.createPager(vm.noticeListModel.pager, vm, "list");

        vm.noticeListModel.list = vm.noticeListModel.list.concat(response.data.noticeList);

        vm.fnSetUIbyTabType("notice")
        if (response.data.totalCount == vm.noticeListModel.list.length) {
          vm.noticeListModel.showMore = false;
        } else {
          vm.noticeListModel.showMore = true;
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnPostDetail() {
      let vm = this;
      let _uid = $("#uid").val();
      let param = {
        uidKey: _uid
      };
      Axios.post("/api/notice/detail", param).then(function (response) {

        vm.noticeDetailModel.detail = response.data.noticeDetail;
        vm.noticeDetailModel.fileEtcList = response.data.fileEtcList;
        vm.noticeDetailModel.fileImgList = response.data.fileImgList;
        vm.noticeDetailModel.fileVdList = response.data.fileVdList;

        vm.noticeDetailModel.fileEtcList.forEach(function (file) {
          file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.noticeDetailModel.fileImgList.forEach(function (file) {
          file.fileUrl = "/img/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.noticeDetailModel.fileVdList.forEach(function (file) {
          file.fileUrl = "/video/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
        });

        document.title = response.data.noticeDetail.title;

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnSetCode: function (_code) {
      let vm = this;
      let param = {
        searchCode: _code
      };

      Axios.post("/api/expinfo/code", param).then(function (response) {
        vm.declareList = response.data.expinfoCodeList;

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnOnDeclarePopup() {
      let vm = this;
      let _userKey = $("#userKey").val();

      if (_userKey != null && _userKey != "") {
        let param = {
          uidKey: $("#uid").val(),
          userKey: _userKey
        };

        Axios.post("/api/expinfo/isDeclare", param).then(function (response) {
          let result = response.data.result;
          if (result == 1) {
            vm.fnSwalAlert("접수된 신고 이력이 있습니다.");
          } else {
            vm.isDeclare = true;
          }

        }).catch(function (ex) {
          console.log(ex);
        });
      } else {
        swal({
          text: "신고하기는 로그인한 회원만 가능합니다.\n 로그인하시겠습니까?",
          closeOnClickOutside: false,
          // // icon: vm.fnOnLoadSwalImageData('info'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      }
    },
    fnOffDeclarePopup() {
      let vm = this;
      vm.isDeclare = false;
      vm.declareReportValues = "";
      vm.declareReportEtc = "";
    },
    fnInsertDeclare() {
      let vm = this;

      let param = {
        userId: $("#userId").val(),
        userKey: $("#userKey").val(),
        boardUid: $("#uid").val(),
        reportKey: vm.declareReportCode,
        reportEtc: vm.declareReportEtc,
        boardCtg: "RCMNVYTHNV00200"
      };

      let declareReportCode = vm.declareReportCode == "" ? false : true;

      if (!declareReportCode) {
        vm.fnSwalAlert('신고사유가 선택되지않았습니다.');
        return false;
      } else if (vm.declareReportCode == "RPTNVYTHNV00400") {
        let declareReportEtc = vm.declareReportEtc == "" ? false : true;
        if (!declareReportEtc) {
          vm.fnSwalAlert('기타항목이 입력되지않았습니다.');
          return false;
        }
      }

      Axios.post("/api/expinfo/insertDeclare", param).then(function (response) {
        let result = response.data.result;
        if (result > 0) {
          vm.fnSwalSuccess("신고가 접수되었습니다.", setTimeout(function () {
            vm.fnOffDeclarePopup();
          }, 1500));
        } else if (result == -999) {
          swal({
            title: '접수 실패',
            text: '신고접수에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          vm.fnSwalAlert("오류가 발생하였습니다.");
        }
      }).catch(function (ex) {
        console.log(ex);
        vm.fnSwalAlert("오류가 발생하였습니다.");
      });
    },
    fnFaqCodeMatch(value) {
      let vm = this;
      if (value == "" || value == null) {
        return "";
      } else {
        const faq = vm.viewModel.qnaTypeList.find(item => item.cmm_sys_cd == value);
        if (faq != null) {
          return faq.cmm_sys_titl;
        } else {
          return "";
        }
      }
    },
    accordionChild: function () {
      $('.accordionsm_js').each(function () {
        var targetId = $(this).attr('id');
        var wrapper = $('#' + targetId);
        var acd_list = wrapper.find('.acdlistsm_js');

        wrapper.find('.acdcntsm_js').hide();

        // '.on'이 붙은 아이는 페이지 진입시 열어놓기
        acd_list.filter('.on').next('.acdcntsm_js').show();

        acd_list.on('click', function () {
          var thisList = $(this);
          var thisCnt = thisList.next('.acdcntsm_js');
          var notThisList = acd_list.not(thisList);
          var notThisCnt = notThisList.next();

          if (notThisList) {
            notThisList.removeClass('on');
            notThisCnt.slideUp(300);
          }

          thisList.toggleClass('on');
          thisCnt.stop().slideToggle(300);
        });
      })
    },

    // 클릭시 클래스 'on' 제어
    toggleOnClick: function () {
      $('.on_js').on('click', function () {
        $(this).toggleClass('on');
      });
    },
    fnSearchFaq: function () {
      let vm = this;
      let _kind = vm.noticeFaqModel.kind;
      $("#faqCheckbox").children().removeClass("on");
      $("#" + _kind).addClass("on");

      vm.fnOnPostFaq(1);
    },
    fnOnClickAtkList(item) {
      item.checked = !item.checked;
    },
    fnOnPostFaq: function (pageNumber) {
      let vm = this;
      if (pageNumber == 0 || pageNumber == 1) vm.noticeFaqModel.list = [];
      vm.noticeFaqModel.pager.pageNo = pageNumber;
      let param = {
        pageNo: vm.noticeFaqModel.pager.pageNo,
        pageSize: vm.noticeFaqModel.pager.rowSize,
        kind: vm.noticeFaqModel.kind,
        kword: vm.noticeFaqModel.kword
      };

      // vm.funLocationBarUpdate({pageNum: pageNumber, qnaType: null})
      Axios.post("/api/notice/faqlist", param).then(function (response) {

        vm.noticeFaqModel.pager.totalSize = response.data.totalCount;
        vm.noticeFaqModel.pageNum = (vm.noticeFaqModel.pager.pageNo * vm.noticeFaqModel.pager.rowSize) - vm.noticeFaqModel.pager.rowSize;
        Pager.props = Pager.methods.createPager(vm.noticeFaqModel.pager, vm, "list");
        // vm.noticeFaqModel.list = [];
        if (response.data.noticeList.length > 0) {
          response.data.noticeList.forEach(function (item) {
            item.checked = false;
            vm.noticeFaqModel.list.push(item);
          });
        }
        console.log(vm.noticeFaqModel.list)
        //	vm.noticeFaqModel.list = response.data.noticeList;

        vm.fnSetUIbyTabType("faq")


      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnChangeKind(value) {
      let vm = this;

      if (value == "all") {
        vm.faqNm = "전체";
      } else {
        const qnaType = vm.noticeListModel.faqContent.find(item => item.cmm_sys_cd == value);

        let _title = qnaType.cmm_sys_titl;
        vm.faqNm = _title;
      }
    },
    fnOnSetQna() {
      let vm = this;
      vm.fnSetUIbyTabType("qna")
    },
    fnSetNoticeByTab(pageNum = 1) {
      let vm = this;
      this.noticeListModel.kind = "notice"
      vm.fnSetUIbyTabType("notice")
      vm.noticeFaqModel.kword = "";
      vm.noticeListModel.pressSearch = '';
      vm.fnOnPostList(pageNum);
    },
    fnSetFaqByTab(pageNum = 1) {
      let vm = this;
      // 자주묻는 질문 탭 클릭시 검색어 초기화
      vm.noticeFaqModel.kword = "";
      vm.fnSetUIbyTabType("faq")
      vm.noticeListModel.pressSearch = '';
      vm.fnOnSetQnaType(); // FAQ 코드 데이터 조회
      vm.fnOnPostFaq(pageNum);
    },
    fnSetEventByTab(pageNum = 1) {
      let vm = this;
      vm.fnSetUIbyTabType("event")
      vm.noticeListModel.pressSearch = '';
      vm.fnGetEventByMain(1);
    },
    /** 이벤트 서브탭 변경 */
    fnChangeEventSubTab(subTab) {
      const vm = this
      vm.subTab = subTab
      Common.fnLocationBarChangeQuery({subTab})
      vm.fnGetEventByMain(1);
    },

    fnSetPressByTab(pageNum = 1) {
      let vm = this;
      vm.fnSetUIbyTabType("press")
      vm.noticeListModel.pressSearch = '';
      vm.fnGetPressByMain(pageNum);
    },
    /**
     * qna 탭으로 이동
     * @param qnaType '| BRDNVYTHNV00400' 자주묻는질문 코드 <pre>
     *        - 사용된 곳: 홈베이스메인 에서 동아리 문의하기 버튼 /customer/notice?qnaType=BRDNVYTHNV00430
     */
    async fnSetQnaByTab(qnaType) {
      // console.log(`qnaType = ${qnaType}`)
      let vm = this;
      vm.fnSetUIbyTabType("qna")
      // vm.fnAllSetQna() // qna 폼에 필요한 정보(코드값들)들을 로딩
      vm.fnOnSetRes() // 나의 예약 정보 로딩
      vm.fnOnSetCenter() // 기관정보 로딩
      await vm.fnOnSetQnaType() // 코드 목록은 필수라서 await
      const qnaOb = vm.viewModel.qnaTypeList.find(item => item.cmm_sys_cd == qnaType);
      vm.selectQnatypeType = qnaOb;
    },


    /** 나의 예약 정보 로딩 */
    fnOnSetRes() {
      let vm = this;

      let param = {
        userId: $("#userId").val()
      };

      Axios.post("/api/notice/popup/reserveList", param).then(function (response) {

        vm.viewModel.reserList = response.data.noticeProgList;

        if (vm.viewModel.reserList.length == 0) {

          vm.viewModel.reserList = [{
            title: "내역이 없습니다.",
            insertdate: "2021-09-10",
            puid: "no",
            price: "0",
            uid: "NO",
            centername: "없음"
          }];
          vm.qnaInsertModel.isEmptyPrgm = true;
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    /** 기관정보 로딩 */
    fnOnSetCenter() {
      let vm = this;
      let param = {};

      Axios.post("/api/notice/popup/centerList", param).then(function (response) {
        vm.viewModel.centerList = response.data.noticeCustList;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    /** FAQ 코드 데이터 조회 */
    async fnOnSetQnaType() {
      let vm = this;
      let param = {upCode: 'BRDNVYTHNV00400'}

      try {
        const response = await Axios.post("/api/notice/selectCode", param)

        vm.viewModel.qnaTypeList = response.data.codeList;
        vm.noticeListModel.faqContent = response.data.codeList;

        if (vm.viewModel.qnaTypeList.length > 0) {
          vm.viewModel.qnaTypeList.forEach(function (object) {
            if (object.cmm_sys_cd == response.data.codeList.cmm_sys_cd) {
              vm.selectQnatypeType = object;
            }
          });
        }
      } catch (ex) {
        console.log(ex);
      }
    },
    onEditorChange: function (event) {
      this.qnaInsertModel.inquiry = event.html;
      this.$emit('getEditorInfo', event);
    },

    /** qna 폼 화면에 필요한 정보들을 로딩 */
    fnAllSetQna() {
      const vm = this

      // vm.fnOnSetQna();
      vm.fnOnSetRes() // 나의 예약 정보 로딩
      vm.fnOnSetCenter() // 기관정보 로딩
      // vm.fnOnSetQnaType();
      // vm.fnSetUIbyTabType("qna")
    },
    fnOnPostFacilityList: function (pageNumber) {
      let vm = this;
      $('#load-2').show();
      if (pageNumber == 1) {
        vm.facilityInfoModel.facList = [];
      }

      vm.facilityInfoModel.pager.pageNo = pageNumber;
      let param = {
        pageNo: vm.facilityInfoModel.pager.pageNo,
        pageSize: vm.facilityInfoModel.pager.rowSize,
        kind: vm.facilityInfoModel.kind,
        kword: vm.facilityInfoModel.kword,
        categoryList: vm.facilityInfoModel.scopeValues,
        sort: vm.facilityInfoModel.sort,
        userKey: $("#userKey").val()
      }

      Axios.post("/api/notice/facilityList", param).then(function (response) {

        vm.facilityInfoModel.pager.totalSize = response.data.totalCount;
        vm.facilityInfoModel.pageNum = (vm.facilityInfoModel.pager.pageNo * vm.facilityInfoModel.pager.rowSize) - vm.facilityInfoModel.pager.rowSize;
        Pager.props = Pager.methods.createPager(vm.facilityInfoModel.pager, vm, "list");

        // vm.facilityInfoModel.facList = [];
        console.log(response.data.noticeFacilityList);
        var now = new Date();
        now = now.getFullYear().toString().padStart(4, "0") + '-' + (now.getMonth() + 1).toString().padStart(2, "0") + '-' + now.getDate().toString().padStart(2, "0");
        response.data.noticeFacilityList.forEach(function (item) {
          if (item.zzimYn == "N") {
            item.isZzim = false;
          } else if (item.zzimYn == "Y") {
            item.isZzim = true;
          }
          if (item.rcpEndDate < now) {
            item.status = "접수종료";
          }
          vm.facilityInfoModel.facList.push(item);
        });
        vm.rm = Math.min(5, Math.floor(vm.facilityInfoModel.facList.length / 4));
        let param = {
          pageNo: vm.facilityInfoModel.pager.pageNo,
          pageSize: vm.facilityInfoModel.pager.rowSize,
          kind: vm.facilityInfoModel.kind,
          kword: vm.facilityInfoModel.kword,
          categoryList: vm.facilityInfoModel.scopeValues,
          sort: "ai",
          userKey: $("#userKey").val()
        }
        Axios.post("/api/notice/facilityList", param).then(function (response) {
          var now = new Date();
          now = now.getFullYear().toString().padStart(4, "0") + '-' + (now.getMonth() + 1).toString().padStart(2, "0") + '-' + now.getDate().toString().padStart(2, "0");
          response.data.noticeFacilityList.forEach(function (item) {
            if (item.zzimYn == "N") {
              item.isZzim = false;
            } else if (item.zzimYn == "Y") {
              item.isZzim = true;
            }
            if (item.rcpEndDate < now) {
              item.status = "접수종료";
            }
            vm.facilityInfoModel.aiFacList.push(item);
          });
          $('#load-2').hide();
        }).catch(function (ex) {
          console.log(ex);
          $('#load-2').hide();
        });
      }).catch(function (ex) {
        console.log(ex);
        $('#load-2').hide();
      });
    },
    fnCheckZzim(_item) {
      let _userKey = $("#userKey").val();

      if (_userKey != null && _userKey != "") {
        _item.isZzim = !_item.isZzim
        _item.zzimYn = (_item.isZzim) ? 'Y' : 'N';

        let param = {
          userId: $("#userId").val(),
          userKey: _userKey,
          facUid: _item.uidKey,
          zzimYn: _item.zzimYn
        };

        Axios.post("/api/notice/checkZzim", param)
          .then(function (response) {
            let result = response.data.result;
          })
          .catch(function (ex) {
            this.fnSwalAlert("오류가 발생하였습니다.");
            console.log(ex);
          });
      } else {
        swal({
          text: "찜하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      }
    },
    /** kind 값 변경 */
    fnKindChange(kind) {
      this.noticeListModel.kind = kind

      if (kind == "notice") {
        vm.fnSetUIbyTabType("notice")
      }

      this.fnOnPostList(1);
    },
    fnFaqKindChange(_kind) {
      this.noticeFaqModel.kind = _kind
      this.fnChangeKind(_kind);
      $("#faqCheckbox").children().removeClass("on");
      $("#" + _kind).addClass("on");
      this.fnOnPostFaq(1);
    },
    //셀렉트박스 변경
    fnSelectGroup($event) {
      this.noticeFaqModel.kind = $event.target.value;
    },
    fnSearchSelectChange() {
      const code = this.facilityInfoModel.searchSelectBox.find(this.fnSame);

      this.facilityInfoModel.kindText = code.value;
    },
    fnSame(element) {
      if (element.code === this.facilityInfoModel.kind) {
        return true;
      }
    },
    //리셋
    fnResetSearch() {
      $("#kind").val('all');
      $("#kword").val('');
      $("#all").trigger('click');
    },
    //검색부
    fnOnClickSearch() {
      let searchid = $(".on").attr("id");

      if (searchid == 'News') {
        this.fnOnPostNews(0, 'news');
      } else if (searchid == 'Notice') {
        this.fnKindChange('공지사항');
      } else if (searchid == 'Event') {
        this.fnKindChange('이벤트당첨발표');
      } else {
        this.fnKindChange('all');
      }
    },
    //faq - 검색
    fnOnClickSearchFaq() {
      let searchKind = this.noticeFaqModel.kind;

      if (searchKind == 'News') {
        this.fnOnPostNews(0, 'news');
      } else if (searchKind == 'Notice') {
        this.fnKindChange('공지사항');
      } else if (searchKind == 'Event') {
        this.fnKindChange('이벤트당첨발표');
      } else {
        this.fnFaqKindChange('all');
      }
    },
    //faq 검색어 나와있는거 누를 때 검색 함수
    fnDirectSearch(searchword) {
      let vm = this;
      vm.noticeFaqModel.kind = 'all';
      vm.faqNm = "전체";
      vm.noticeFaqModel.kword = searchword;

      $("#faqCheckbox").children().removeClass("on");
      $("#faqCheckbox").children().first().addClass("on");
      vm.fnOnPostFaq(1);
    },
    fnSort(_sort) {
      this.facilityInfoModel.sort = _sort;
      this.fnOnPostFacilityList(1);
    },
    //페이지 이동
    fnGotoDetail(uid) {
      let vm = this;
      if (uid == "NO") {
        location.href = "javascript:void(0)";
      } else {
        let pageNum = vm.noticeListModel.pager.pageNo;
        let searchWord = vm.noticeListModel.kword;

        location.href = "/customer/notice/goNoticeDetail?uid=" + uid;
      }
    },
    fnGotoNoticeList() {
      location.href = "/customer/notice/notice";
    },
    fnGoToPressLink(url) {
      window.open(url, '_blank');
    }
    /****************************************************************/,

    //검색 자동완성 함수
    changeResValue(str) {

      this.isResActive = false;
      document.querySelector('.s.res').value = str;
      this.viewModel.resValue = str;
      this.qnaInsertModel.reserveTitle = str;

      this.setResInfo();
    },
    setResInfo() {
      const resInfo = this.viewModel.reserList.find(this.isSame);

      this.qnaInsertModel.reservePuid = resInfo.programUid;
      this.qnaInsertModel.reserveID = resInfo.programRegUid;
      this.qnaInsertModel.reserveDate = resInfo.insertDate;
      this.qnaInsertModel.centername_input = resInfo.centerName;
      this.qnaInsertModel.centeruid = resInfo.centerUid;

      $("#reserveEl").empty();
    },
    setCenInfo() {
      const cenInfo = this.viewModel.centerList.find(this.isCenSame);

      this.qnaInsertModel.centeruid = cenInfo.userKey;

      $("#centerEl").empty();

    },
    isSame(element) {
      if (element.programName === this.viewModel.resValue) {
        return true;
      }
    },
    isCenSame(element) {
      if (element.userName === this.viewModel.cenValue) {
        return true;
      }
    },
    changeCenValue(str) {

      this.isCenActive = false;
      document.querySelector('.s.cen').value = str;
      this.viewModel.cenValue = str;
      this.qnaInsertModel.centername = str;
      this.setCenInfo();
    },
    selectResValue(keycode, str) {
      if (this.viewModel.isResActive === true) {
        const hasClass = document.querySelector('.r').classList.contains('key');
        if (keycode === 'down') {
          if (!hasClass) {
            const thisEl = document.querySelectorAll('.r li')[0];
            document.querySelector('.r').classList.add('key');
            thisEl.classList.add('sel');
            thisEl.focus();
          } else {
            const lastEl = document.querySelector('.r li:last-child');
            const thisEl = document.querySelector('.r li.sel');
            const nextEl = thisEl.nextElementSibling;
            if (!lastEl.classList.contains('sel')) {
              thisEl.classList.remove('sel');
              nextEl.classList.add('sel');
              nextEl.focus();
            }
          }
        }
        if (keycode === 'up' && hasClass) {
          const firstEl = document.querySelectorAll('.r li')[0];
          const thisEl = document.querySelector('.r li.sel');
          const prevEl = thisEl.previousElementSibling;
          if (!firstEl.classList.contains('sel')) {
            thisEl.classList.remove('sel');
            prevEl.classList.add('sel');
            prevEl.focus();
          } else {
            document.querySelector('.s').focus();
          }
        }
        if (keycode === 'enter' && hasClass) {
          this.changeResValue(str);
        }
      }
    },
    selectCenValue(keycode, str) {
      if (this.viewModel.isCenActive === true) {
        const hasClass = document.querySelector('.r').classList.contains('key');
        if (keycode === 'down') {
          if (!hasClass) {
            const thisEl = document.querySelectorAll('.r li')[0];
            document.querySelector('.r').classList.add('key');
            thisEl.classList.add('sel');
            thisEl.focus();
          } else {
            const lastEl = document.querySelector('.r li:last-child');
            const thisEl = document.querySelector('.r li.sel');
            const nextEl = thisEl.nextElementSibling;
            if (!lastEl.classList.contains('sel')) {
              thisEl.classList.remove('sel');
              nextEl.classList.add('sel');
              nextEl.focus();
            }
          }
        }
        if (keycode === 'up' && hasClass) {
          const firstEl = document.querySelectorAll('.r li')[0];
          const thisEl = document.querySelector('.r li.sel');
          const prevEl = thisEl.previousElementSibling;
          if (!firstEl.classList.contains('sel')) {
            thisEl.classList.remove('sel');
            prevEl.classList.add('sel');
            prevEl.focus();
          } else {
            document.querySelector('.s').focus();
          }
        }
        if (keycode === 'enter' && hasClass) {
          this.changeCenValue(str);
        }
      }
    },
    removeValue() {
      if (document.querySelector('.r').classList.contains('key')) {
        document.querySelector('.r').classList.remove('key');
        document.querySelector('.r li.sel').classList.remove('sel');
      }
    },
    resetForm() {
      this.qnaInsertModel.reservePuid = '';
      this.qnaInsertModel.reserveID = '';
      this.qnaInsertModel.reserveDate = '';
      this.qnaInsertModel.reserveTitle_input = '';
      this.qnaInsertModel.reserveTitle = '';

      this.qnaInsertModel.centeruid = '';
      this.qnaInsertModel.centername = '';
      this.qnaInsertModel.centername_input = '';

      $("#reserveEl").empty();
      $("#centerEl").empty();
    },
    checkInsertEmail($event) {
      let _value = $event.target.value;

      if (_value == '' || _value == null) {
        $("#emailkind_name").removeAttr('disabled');
      } else {
        $("#emailkind_name").attr("disabled", true);
      }
    },
    validationQna() {
      let vm = this;
      let _title = vm.qnaInsertModel.title.trim() == "" ? false : true;
      let _inquiry = vm.qnaInsertModel.inquiry.trim() == "" ? false : true;
      let _type = vm.qnaInsertModel.qnaType == "" ? false : true;

     if (!_type) {
        swal("구분을 선택해주세요.").then(function () {
          console.log("test")
          $('#type').focus();
        });
        return false;
      } else if (!_title) {
        //SwalAlert.methods.fnOnClickErrorAlert('error', '제목이 입력되지 않았습니다.',
        // '제목을 입력해주세요.', null, null);
        swal("제목을 입력해주세요.").then(function () {
          $('#title').focus();
        });
        return false;
      } //else if (!_qna_type) {
        // SwalAlert.methods.fnOnClickErrorAlert('error', '문의유형이 선택되지 않았습니다.',
        //  '유형을 선택해주세요.', null, null);
        //return false;
        //}
        // else if (vm.qnaInsertModel.qnaType == "BRDNVYTHNV00420") {
        //   if (vm.qnaInsertModel.isInput) {
        //     let reserveTitle_input = vm.qnaInsertModel.reserveTitle_input == "" ? false : true;
        //     let centername = vm.qnaInsertModel.centername == "" ? false : true;
        //
        //     if (!reserveTitle_input) {
        //       SwalAlert.methods.fnOnClickErrorAlert('error', '프로그램명이 입력되지 않았습니다.',
        //         '이수한 프로그램명을 입력해주세요.', null, null);
        //       return false;
        //     } else if (!centername) {
        //       SwalAlert.methods.fnOnClickErrorAlert('error', '기관이 입력되지 않았습니다.',
        //         '기관을 입력해주세요.', null, null);
        //       return false;
        //     }
        //   } else {
        //     let reserveTitle = vm.qnaInsertModel.reserveTitle == "" ? false : true;
        //     if (!reserveTitle) {
        //       SwalAlert.methods.fnOnClickErrorAlert('error', '프로그램명이 입력되지 않았습니다.',
        //         '이수한 프로그램명을 입력해주세요.', null, null);
        //       return false;
        //     }
        //   }
      // }
      else if (!_inquiry) {
        //SwalAlert.methods.fnOnClickErrorAlert('error', '내용이 입력되지 않았습니다.',
        //  '내용을 입력해주세요.', null, null);
        swal("내용을 입력해주세요.").then(function () {
          $('#content').focus();
        });
        return false;
      }

      if (_title && _inquiry) {
        return true;
      }
    },
    submitQna() {
      let vm = this;
      var _programuid = '';
      var _programname = '';
      var _centername = '';
      var _centeruid = '';
      var _reserveid = '';

      if (vm.qnaInsertModel.isInput) {
        _programname = vm.qnaInsertModel.reserveTitle_input;
        _programuid = '';
        _reserveid = '';
        _centername = vm.qnaInsertModel.centername;
        _centeruid = vm.qnaInsertModel.centeruid;
      } else {
        _programname = '';
        _programuid = vm.qnaInsertModel.reservePuid;
        _reserveid = vm.qnaInsertModel.reserveID;
        _centername = vm.qnaInsertModel.centername_input;
        _centeruid = vm.qnaInsertModel.centeruid;
      }

      _programname = vm.qnaInsertModel.reserveTitle_input;

      let param = {
        userId: vm.qnaInsertModel.userId,
        // userKey : vm.qnaInsertModel.userKey,
        userKey: $("#userKey").val(), // 로그인한 회원의 key 사용
        title: vm.qnaInsertModel.title,
        qnaType: vm.qnaInsertModel.qnaType,
        content: vm.qnaInsertModel.inquiry,
        programuid: _programuid,
        programname: _programname,
        reserveid: _reserveid,
        centername: _centername,
        centeruid: _centeruid
      };
      if (vm.validationQna()) {
        Axios.post("/api/notice/insertQna", param).then(function (response) {
          let result = response.data.result;

          if (result > 0) {
            //location.href='/'
            vm.fnSwalSuccess("문의사항이 등록되었습니다.", setTimeout(function () {
              location.reload();
            }, 2000));
          } else if (result == -999) {
            swal({
              title: '등록 실패',
              text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon: vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert("문의사항 등록에 실패하였습니다.");
          }

        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert("문의사항 등록에 실패하였습니다.");
          return false;
        });
      }
    },
    fnGotoFacInfo(uidKey) {
      location.href = "/customer/notice/facilityDetail?uidKey=" + uidKey;
    },
    fnSwalAlert(_text) {
      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon: this.fnOnLoadSwalImageData('warning'),
        buttons: {
          confirm: {
            text: "확인",
            value: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      });
    },
    fnSwalSuccess(_text, successFunction) {
      let vm = this;

      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon: vm.fnOnLoadSwalImageData("success"),
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      }).then(result => {
        if (result) {
          if (successFunction != null) {
            successFunction();
          }
        }
      });
    },
    fnChgTelNum: function (telNum) {
      let result = [];
      let restNumber = '';


      if (!telNum) {
        return "";
      }


      let value = telNum.replace(/[^0-9]/g, "");
      // 지역번호와 나머지 번호로 나누기
      if (value.startsWith("02")) {
        // 서울 02 지역번호
        result.push(value.substr(0, 2));
        restNumber = value.substring(2);
      } else if (value.startsWith("1")) {
        // 지역 번호가 없는 경우
        // 1xxx-yyyy
        restNumber = value;
      } else {
        // 나머지 3자리 지역번호
        // 0xx-yyyy-zzzz
        result.push(value.substr(0, 3));
        restNumber = value.substring(3);
      }


      if (restNumber.length === 7) {
        // 7자리만 남았을 때는 xxx-yyyy
        result.push(restNumber.substring(0, 3));
        result.push(restNumber.substring(3));
      } else {
        result.push(restNumber.substring(0, 4));
        result.push(restNumber.substring(4));
      }
      let tmpTel = result.filter((val) => val).join("-");
      return tmpTel;
    }

    /*******************************************************************/
    /*============================================================ 공유 start ========================================================================*/,
    fnOnClickSharePop: function () {
      this.isShare = true;
    },
    fnOnClickCloseSharePop: function () {
      this.isShare = false;
    },
    fnOnLoadKakaoContent: function (value) {

      let _atag = value.replace(/<(\/a|a|\/img|img|\/br|br|\/p|p)([^>]*)>/gi, "");
      let _nbsptag = _atag.replace(/&nbsp;/gi, "");
      let _httptag = _nbsptag.replace(/^(((http(s?))\:\/\/))([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?/, "");

      return (_httptag.length >= 200) ? _httptag.substring(0, 200).concat('...') : _httptag;

    },
    fnOnClickKakaoShare: function () {
      // vm.pareDetailModel.pareContents
      let vm = this;
      let _data = vm.fnOnLoadKakaoContent(vm.noticeDetailModel.detail.contentFirst);

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;

        let _uri = urlAddress + '/customer/notice/goNoticeDetail?uid=' + vm.noticeDetailModel.detail.uidKey + "&shared=Y";

        vm.fnShareLog(vm.noticeDetailModel.detail.uidKey);

        Share.methods.fnOnCreateKakaoShareUrl(_uri,
          vm.noticeDetailModel.detail.title,
          "",
          //, 'http://localhost:8080'+ vm.pareDetailModel.pareContents.imagePath
          "",
          "",
          "",
          "",
          ""
        );
      });
    },
    fnOnClickNaverShare: function () {
      let vm = this;
      let _uri = '';
      let _imgPath = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        _uri = urlAddress + '/customer/notice/goNoticeDetail?uid=' + vm.noticeDetailModel.detail.uidKey + "&shared=Y";


        if (vm.noticeDetailModel.detail.imagePath == '' || vm.noticeDetailModel.detail.imagePath == null) {
          _imgPath = urlAddress + "/" + vm.noticeDetailModel.detail.imagePath;
        } else {
          _imgPath = urlAddress + '/design/common/images/sub/img_noimg.png';
        }

        vm.fnShareLog(vm.noticeDetailModel.detail.uidKey);

        Share.methods.fnOnCreateNaverShareUrl(_uri,
          vm.noticeDetailModel.detail.title,
          _imgPath
        );
      });

    },

    clickFunc: function (event) {
      event.target.focus();// Add me
    },
    fnOnClickFacebookShare: function () {
      let vm = this;
      let _uri = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;

        _uri = urlAddress + '/customer/notice/goNoticeDetail?uid=' + vm.noticeDetailModel.detail.uidKey + "&shared=Y";

        vm.fnShareLog(vm.noticeDetailModel.detail.uidKey);

        Share.methods.fnOnCreateFacebookShareUrl(_uri);
      });
    },
    fnOnClickLinkShare: function () {
      let vm = this;
      let target = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;

        target = urlAddress + '/customer/notice/goNoticeDetail?uid=' + vm.noticeDetailModel.detail.uidKey + "&shared=Y";

        vm.fnShareLog(vm.noticeDetailModel.detail.uidKey);

        let _url = '/customer/activity/share/link';
        _url += '?url=' + encodeURIComponent(target);

        window.open(_url, '공유하기', "width=550, height=550, toolbar=no, menubar=no, scrollbars=no, resizable=no");
      });
    },
    fnShareLog(uidKey) {
      Axios.post("/api/logCud/insert", {
        paramUid: uidKey,
        statusCode: "share",
        version: "insert"
      }).then(function (response) {
        let result = response.data.resultCnt;
      });
    },
    fnDeclareEnter: function (value) {
      let vm = this;

      if (vm.declareReportCode.indexOf(value) > -1) {
        vm.declareReportCode = "";
      } else {
        vm.declareReportCode = value;
      }
    },
    /*============================================================ 공유 end ========================================================================*/

    /* ----------- 이벤트, 보도자료 method -------------- */
    /** 페이징 처리 */
    fnSetPager: function (totalCount, etc) {
      let vm = this;
      vm.viewModel.pager.etc = etc
      vm.viewModel.pager.totalSize = totalCount;
      vm.viewModel.pager.pageNum = (vm.viewModel.pager.pageNo * vm.viewModel.pager.rowSize) - vm.viewModel.pager.rowSize;
      Pager.props = Pager.methods.createPager(vm.viewModel.pager, vm, "list");
    },
    /**
     * 이벤트 더보기 버튼
     * @param tab
     */
    OnClickEventMoreBtn: function (tab) {
      let vm = this;
      let pageName = $('#pageName').val();

      if (pageName == 'realinfoMain') {
        let pageNum = vm.viewModel.pager.pageNo;
        let tabIdx = 1;

        if (vm.tabType === 'event') {
          tabIdx = 4;
        } else if (vm.tabType === 'press') {
          tabIdx = 5;
        }
      }
      location.href = "/customer/realinfo/event/list?tab=" + tab;
    },
    /** 메인페이지 이벤트 조회 */
    fnGetEventByMain: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = 12;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      if (pageNumber == 1) {
        vm.noticeListModel.eventContents = [];
      }
      let param = {
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize,
        subTab: vm.subTab,
      };
      // vm.funLocationBarUpdate({pageNum: pageNumber, qnaType: null})
      Axios.post("/api/realinfo/main/event/list", param).then(function (response) {
        vm.noticeListModel.eventContents = vm.noticeListModel.eventContents.concat(response.data.paramBrdDtoList);

        if (response.data.paramBrdDtoListCnt == vm.noticeListModel.eventContents.length) {
          vm.noticeListModel.showMore = false;
        } else {
          vm.noticeListModel.showMore = true;
        }
        // console.log("len : ", vm.noticeListModel.eventContents.length);
        // vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetEventByMain');
      }).catch(function (ex) {
        console.log(ex);
      });

    },
    /** 이벤트 당첨발표 클릭 */
    OnClickEventAnnounceDetail(uidKey) {

      // let vm = this;
      //
      // let pageName = $('#pageName').val();
      //
      // if (pageName === 'realinfoMain') {
      //   let pageNum = vm.viewModel.pager.pageNo;
      //   let tabIdx = 1;
      //
      //   if (vm.mainViewModel.isEvent) {
      //     tabIdx = 4;
      //   } else if (vm.mainViewModel.isPress) {
      //     tabIdx = 5;
      //   }
      //
      // } else if (pageName === 'eventList') {
      //   let pageNum = vm.viewModel.pager.pageNo;
      //   let tab = 1;
      //
      //   if (vm.mainViewModel.subCatCd === 'BRDNVYTHNV00220') {
      //     tab = 2;
      //   }
      //
      // } else {
      //   console.warn(`정의되지 않은 pageName = ${pageName}`)
      // }


      const retu = encodeURIComponent(location.pathname + location.search)

      location.href = "/customer/realinfo/eventAnnounce?uidKey=" + uidKey + "&retp=" + retu;
    },

    /** 메인페이지 보도자료 조회 */
    fnGetPressByMain: function (pageNumber) {
      let vm = this;
      if (pageNumber < 2) vm.noticeListModel.pressContents = []
      vm.viewModel.pager.rowSize = 6;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      let _param = {keyword: vm.noticeListModel.pressSearch}
      let param = {
        param: _param,
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize
      }
      // vm.funLocationBarUpdate({pageNum: pageNumber, qnaType: null})
      Axios.post("/api/realinfo/main/press", param).then(function (response) {
        console.log(response.data);
        vm.noticeListModel.pressContents = vm.noticeListModel.pressContents.concat(response.data.paramBrdDtoList);
        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetPressByMain');
        if (response.data.paramBrdDtoListCnt == vm.noticeListModel.pressContents.length) {
          vm.noticeListModel.showMore = false;
        } else {
          vm.noticeListModel.showMore = true;
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
  },
  watch: {
    selectQnatypeType: function (newValue, oldValue) {
      // console.log(`[watch] selectQnatypeType : newValue = ${newValue}, oldValue = ${oldValue} `)
      this.inputQnatypeLabel = (newValue != '' && newValue != undefined && newValue != null) ? newValue.cmm_sys_titl : '';
      this.qnaInsertModel.qnaType = newValue.cmm_sys_cd;
    }
  },
  computed: {
    filterReserList() {
      let vm = this;
      const str = this.viewModel.searchResQuery;
      const reg = /[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9|\s]/.test(str);

      if (reg === false && str !== '' && str !== ' ') {
        this.viewModel.isResActive = true;
        return this.viewModel.reserList.filter((el) => {
          return el.programName.match(str);
        });
      } else {
        this.viewModel.isResActive = false;
      }
    },
    filterCenterList() {
      let vm = this;
      const str = this.viewModel.searchCenQuery;
      const reg = /[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9|\s]/.test(str);

      if (reg === false && str !== '' && str !== ' ') {
        this.viewModel.isCenActive = true;
        return this.viewModel.centerList.filter((el) => {
          return el.userName.match(str);
        });
      } else {
        this.viewModel.isCenActive = false;
      }
    },
  },
  filters: {
    currency: function (value) {
      let num = new Number(value);
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
    },
    facSelectBox: function (value) {
      if (value == "all") {
        return "전체"
      } else if (value == "title") {
        return "제목"
      } else if (value == "content") {
        return "내용"
      }
    },
    facCategory: function (value) {
      if (value == "녹화장소") {
        return "녹화/촬영"
      } else if (value == "민원 등 기타") {
        return "서울시공공예약프로그램"
      } else if (value == "주민공유공간") {
        return "주민사랑방"
      } else {
        return value;
      }
    },
    facTitle: function (value) {
      let title = value;
      if (value == null || value == "") {
        title = value;
      } else {
        title = title.replace(/&lt;/gi, "<");
        title = title.replace(/&gt;/gi, ">");
      }
      return title;
    }
  }
});

